/* OM v13: quick add (inline size picker) + collection filters. Vanilla, no libraries.
   Classic deferred script so taps work as soon as the page is parsed; Horizon's cart event classes are
   loaded on demand (dynamic import honours the theme import map). */
(() => {
let EV = null;
const events = () => EV || (EV = import('@shopify/events').catch(() => null));

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

/* ---------- add to cart through Horizon's own event pipeline (drawer re-renders + auto-opens) ---------- */
async function addToCart(source, variantId, qty = 1) {
  const mod = await events();
  const CartLinesUpdateEvent = mod && mod.CartLinesUpdateEvent;
  const CartErrorEvent = mod && mod.CartErrorEvent;
  let deferred = { resolve() {}, reject() {} };
  if (CartLinesUpdateEvent) {
    deferred = CartLinesUpdateEvent.createPromise();
    source.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: qty }],
      promise: deferred.promise,
    }));
  }
  const sectionIds = $$('cart-items-component').map((c) => c.dataset.sectionId).filter(Boolean);
  const fd = new FormData();
  fd.set('id', String(variantId));
  fd.set('quantity', String(qty));
  if (sectionIds.length) fd.set('sections', sectionIds.join(','));
  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd,
    }).then((r) => r.json());
    const cart = await fetch((window.Theme?.routes?.cart_url || '/cart') + '.js').then((r) => r.json());
    if (!CartLinesUpdateEvent) { if (!res.status) location.assign(window.Theme?.routes?.cart_url || '/cart'); return { ok: !res.status, message: res.description || res.message }; }
    if (res.status) {
      if (CartErrorEvent) source.dispatchEvent(new CartErrorEvent({ error: res.message || 'Add to cart failed', code: 'INVALID' }));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'om13-quick-add' } });
      return { ok: false, message: res.description || res.message };
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'om13-quick-add', itemCount: qty, sections: res.sections, didError: false },
    });
    return { ok: true };
  } catch (e) {
    deferred.reject(e);
    return { ok: false, message: 'Something went wrong. Try again?' };
  }
}

/* ---------- quick add on cards ---------- */
function variantsOf(card) {
  if (!card._v) { try { card._v = JSON.parse($('[data-om13-v]', card).textContent); } catch (e) { card._v = []; } }
  return card._v; /* [id, colour, size, available] */
}
function currentColour(card) {
  const b = $('[data-om13-colour][aria-pressed="true"]', card) || $('[data-om13-colour]', card);
  return b ? b.dataset.om13Colour : '';
}
function renderSizes(card) {
  const box = $('[data-om13-sizes]', card);
  if (!box) return;
  const colour = currentColour(card);
  const list = variantsOf(card).filter((v) => !colour || v[1] === colour);
  box.innerHTML = '';
  list.forEach((v) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'om13-chip om13-chip--s';
    b.textContent = v[2];
    b.dataset.om13Add = v[0];
    if (!v[3]) { b.disabled = true; b.setAttribute('aria-label', v[2] + ', sold out'); }
    else b.setAttribute('aria-label', 'Add size ' + v[2] + (colour ? ', ' + colour : '') + ' to cart');
    box.appendChild(b);
  });
}
document.addEventListener('click', async (e) => {
  const qa = e.target.closest('[data-om13-qa]');
  if (qa) {
    const card = qa.closest('[data-om13-card]');
    const panel = $('.om13-qa', card);
    const open = qa.getAttribute('aria-expanded') !== 'true';
    $$('[data-om13-qa][aria-expanded="true"]').forEach((b) => { if (b !== qa) { b.setAttribute('aria-expanded', 'false'); const p = $('.om13-qa', b.closest('[data-om13-card]')); if (p) p.hidden = true; } });
    qa.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) { renderSizes(card); const first = $('[data-om13-sizes] button:not([disabled])', card); if (first) first.focus({ preventScroll: true }); }
    return;
  }
  const col = e.target.closest('[data-om13-colour]');
  if (col) {
    const card = col.closest('[data-om13-card]');
    $$('[data-om13-colour]', card).forEach((b) => b.setAttribute('aria-pressed', b === col ? 'true' : 'false'));
    renderSizes(card);
    return;
  }
  const add = e.target.closest('[data-om13-add]');
  if (add) {
    const card = add.closest('[data-om13-card]');
    const msg = card && $('.om13-qa__msg', card);
    add.disabled = true; add.classList.add('is-busy');
    const r = await addToCart(add, add.dataset.om13Add);
    add.disabled = false; add.classList.remove('is-busy');
    if (msg) msg.textContent = r.ok ? 'Added. Nice pick.' : (r.message || 'Could not add that one.');
    if (r.ok && card) {
      const btn = $('[data-om13-qa]', card);
      setTimeout(() => { if (btn) { btn.setAttribute('aria-expanded', 'false'); const p = $('.om13-qa', card); if (p) p.hidden = true; } if (msg) msg.textContent = ''; }, 1600);
    }
  }
});

/* ---------- collection filters ---------- */
const col = $('[data-om13-col]');
if (col) {
  const grid = $('[data-om13-grid]', col);
  const items = $$('li[data-i]', grid);
  const cards = items.map((li) => ({ li, c: $('[data-om13-card]', li) })).filter((x) => x.c);
  const state = { design: '', type: new Set(), fit: new Set(), colour: new Set(), size: new Set() };
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '2T', '3T', '4T', '5T'];
  const vals = (attr) => {
    const set = new Set();
    cards.forEach(({ c }) => (c.dataset[attr] || '').split('|').forEach((v) => v && set.add(v)));
    return Array.from(set);
  };
  const groups = [
    ['type', 'Type', vals('type')],
    ['fit', 'Fit', ['Men', 'Women', 'Kids', 'Toddler', 'Unisex'].filter((f) => vals('fit').includes(f))],
    ['colour', 'Colour', vals('colours').sort()],
    ['size', 'Size', vals('sizes').sort((a, b) => SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b))],
  ];
  const box = $('[data-om13-groups]', col);
  groups.forEach(([key, label, list]) => {
    if (list.length < 2) return;
    const fs = document.createElement('fieldset');
    fs.className = 'om13-sheet__group';
    fs.innerHTML = '<legend>' + label + '</legend>';
    const row = document.createElement('div'); row.className = 'om13-qa__row';
    list.forEach((v) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'om13-chip'; b.textContent = v;
      b.dataset.om13F = key; b.dataset.v = v; b.setAttribute('aria-pressed', 'false');
      row.appendChild(b);
    });
    fs.appendChild(row); box.appendChild(fs);
  });
  const designBtns = $$('[data-om13-f="design"]', col);
  { const cur = $('.om13-col__designs a[aria-current]', col), g = $('.om13-col__designs', col); if (cur && g && g.scrollWidth > g.clientWidth) g.scrollLeft = cur.offsetLeft - (g.clientWidth - cur.offsetWidth) / 2; }
  if (designBtns.length <= 2 && !$('[data-om13-design-links]', col)) { const g = $('.om13-col__designs', col); if (g) g.hidden = true; }

  const has = (c, attr, set) => !set.size || (c.dataset[attr] || '').split('|').some((v) => set.has(v));
  function apply() {
    let n = 0;
    cards.forEach(({ li, c }) => {
      const ok = (!state.design || c.dataset.design === state.design)
        && has(c, 'type', state.type) && has(c, 'fit', state.fit) && has(c, 'colours', state.colour) && has(c, 'sizes', state.size);
      li.hidden = !ok; if (ok) n++;
    });
    $$('[data-om13-count],[data-om13-count2]', col).forEach((el) => (el.textContent = n));
    $('[data-om13-empty]', col).hidden = n > 0;
    const active = state.type.size + state.fit.size + state.colour.size + state.size.size;
    const badge = $('[data-om13-active-n]', col); badge.hidden = !active; badge.textContent = active;
    const params = new URLSearchParams(location.search);
    ['design', 'type', 'fit', 'colour', 'size'].forEach((k) => {
      const v = k === 'design' ? state.design : Array.from(state[k]).join(',');
      if (v) params.set(k, v); else params.delete(k);
    });
    history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : ''));
  }
  function sync() {
    $$('[data-om13-f]', col).forEach((b) => {
      const k = b.dataset.om13F, v = b.dataset.v;
      b.setAttribute('aria-pressed', String(k === 'design' ? state.design === v : state[k].has(v)));
    });
  }
  col.addEventListener('click', (e) => {
    const f = e.target.closest('[data-om13-f]');
    if (f) {
      const k = f.dataset.om13F, v = f.dataset.v;
      if (k === 'design') state.design = v; else state[k].has(v) ? state[k].delete(v) : state[k].add(v);
      sync(); apply(); return;
    }
    if (e.target.closest('[data-om13-clear]')) {
      state.design = ''; ['type', 'fit', 'colour', 'size'].forEach((k) => state[k].clear()); sync(); apply(); return;
    }
    const sheet = $('[data-om13-sheet]', col);
    if (e.target.closest('[data-om13-filters-open]')) { sheet.showModal(); return; }
    if (e.target.closest('[data-om13-sheet-close]') || e.target === sheet) sheet.close();
  });
  $('[data-om13-sort]', col).addEventListener('change', (e) => {
    const how = e.target.value;
    const price = (x) => Number(x.c.dataset.price || 0);
    const sorted = cards.slice().sort((a, b) =>
      how === 'price-asc' ? price(a) - price(b) : how === 'price-desc' ? price(b) - price(a)
        : how === 'az' ? a.c.dataset.title.localeCompare(b.c.dataset.title) : a.li.dataset.i - b.li.dataset.i);
    sorted.forEach((x) => grid.appendChild(x.li));
  });
  /* restore from URL (?design=jioni&size=M) */
  const q = new URLSearchParams(location.search);
  if (q.get('design')) state.design = q.get('design');
  ['type', 'fit', 'colour', 'size'].forEach((k) => (q.get(k) || '').split(',').forEach((v) => v && state[k].add(v)));
  if ([...q.keys()].length) {
    sync(); apply();
    /* a colour hint (e.g. from the rig quiz) that matches nothing here is dropped rather than showing an empty grid */
    if (!cards.some(({ li }) => !li.hidden) && state.colour.size) { state.colour.clear(); sync(); apply(); }
  }
}
/* ---------- flip design cards ---------- */
function flip(card, on) {
  card.classList.toggle('is-flipped', on);
  const back = card.querySelector('.om13-flip__back');
  const front = card.querySelector('.om13-flip__front');
  if (back) back.inert = !on;
  if (front) front.inert = on;
  card.querySelectorAll('[data-om13-flip-btn]').forEach((b) => b.setAttribute('aria-expanded', String(on)));
}
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-om13-flip-btn]');
  if (!b) return;
  const card = b.closest('[data-om13-flip]');
  const on = !card.classList.contains('is-flipped');
  flip(card, on);
  const target = on ? card.querySelector('.om13-flip__shop') : card.querySelector('.om13-flip__btn');
  if (target) setTimeout(() => target.focus({ preventScroll: true }), on ? 60 : 0);
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const card = e.target.closest && e.target.closest('[data-om13-flip].is-flipped');
  if (card) { flip(card, false); const f = card.querySelector('.om13-flip__btn'); if (f) f.focus(); }
});
/* card image swipe dots */
document.addEventListener('scroll', (e) => {
  const m = e.target;
  if (!(m instanceof Element) || !m.classList.contains('om13-card__media--duo')) return;
  const i = Math.round(m.scrollLeft / Math.max(1, m.clientWidth));
  const dots = m.parentElement.querySelectorAll('.om13-card__dots i');
  dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
}, { capture: true, passive: true });

/* card worn shots: src set after window load (or on first hover/touch of a card), and for cards added later by filters/pagination */
const wakeAlt = (root) => {
  if (!root || !root.querySelectorAll) return;
  const list = root.matches && root.matches('img[data-om13-src]') ? [root] : root.querySelectorAll('img[data-om13-src]');
  list.forEach((im) => {
    if (im.dataset.om13Srcset) im.setAttribute('srcset', im.dataset.om13Srcset);
    im.setAttribute('src', im.dataset.om13Src);
    im.removeAttribute('data-om13-src'); im.removeAttribute('data-om13-srcset');
  });
};
['pointerover', 'touchstart'].forEach((ev) => document.addEventListener(ev, (e) => {
  const c = e.target.closest && e.target.closest('.om13-card__mwrap');
  if (c) wakeAlt(c);
}, { passive: true, capture: true }));
/* below-the-fold section images (journal teaser, complete the look): src when within ~700px of the viewport */
const lateIO = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
  if (e.isIntersecting) { lateIO.unobserve(e.target); wakeAlt(e.target); }
}), { rootMargin: '700px 0px' }) : null;
const wakeRoot = (root) => {
  if (!root || !root.querySelectorAll) return;
  const list = root.matches && root.matches('img[data-om13-src]') ? [root] : [...root.querySelectorAll('img[data-om13-src]')];
  list.forEach((im) => { if (im.closest('.om13-card__mwrap') || !lateIO) wakeAlt(im); else lateIO.observe(im); });
};
const altAll = () => {
  wakeRoot(document);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && wakeRoot(n)))).observe(document.body, { childList: true, subtree: true });
};
if (document.readyState === 'complete') setTimeout(altAll, 300); else addEventListener('load', () => setTimeout(altAll, 300), { once: true });

/* warm the event module once the page is idle */
(window.requestIdleCallback || setTimeout)(() => events());
})();
